import { Container } from 'react-bootstrap';
import './home/Home.css';

function PageLayout({ hero, children, heroPadding = "py-5", mainPadding = "py-4", heroCenter = false, stickyHero = false }) {
    const hasMain = children !== null && children !== undefined && children !== false;
    return (
        <>
            <Container fluid className={`home-hero text-white${stickyHero ? ' hero-sticky' : ''}`}>
                <Container
                    className={`${heroPadding} position-relative${heroCenter ? ' text-center' : ''}`}
                    style={{ zIndex: 1 }}
                >
                    {hero}
                </Container>
            </Container>
            {hasMain && (
                <Container fluid style={{ backgroundColor: '#fdf4ff' }}>
                    <Container className={mainPadding}>
                        {children}
                    </Container>
                </Container>
            )}
        </>
    );
}

export default PageLayout;
